var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", { style: _vm.componentStyle }, [
    _c(
      "td",
      { staticClass: "text-center" },
      [
        _vm.isRanked
          ? [_vm._v(_vm._s(_vm.requestRank))]
          : [
              _vm.isInProgress
                ? _c(
                    "span",
                    {
                      attrs: {
                        "aria-label": "In Progress",
                        "data-balloon-pos": "right",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v6.solid.faCompassDrafting,
                          "fixed-width": "",
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.isReleased
                ? _c(
                    "span",
                    {
                      attrs: {
                        "aria-label": "Released!",
                        "data-balloon-pos": "right",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v6.solid.faSparkles,
                          "fixed-width": "",
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _c("td", { attrs: { scope: "row" } }, [
      _c(
        "span",
        { staticClass: "display-flex flex-items-center flex-content-between" },
        [
          _c(
            "a",
            {
              staticStyle: { "flex-grow": "1" },
              attrs: { href: _vm.requestUrl, target: "_blank" },
            },
            [_vm._v("\n        " + _vm._s(_vm.requestTitle) + "\n      ")]
          ),
          _vm._v(" "),
          _vm.isInProgress && _vm.isRanked
            ? _c(
                "span",
                {
                  staticClass: "margin-left-lg",
                  attrs: {
                    "aria-label": "In Progress",
                    "data-balloon-pos": "up",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v6.solid.faCompassDrafting,
                      "fixed-width": "",
                      size: "lg",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("font-awesome-icon", {
          staticClass: "margin-right-2xs",
          staticStyle: { color: "var(--fa-gravy)" },
          attrs: {
            icon: _vm.$v6.regular.faMessage,
            "fixed-width": "",
            size: "lg",
          },
        }),
        _vm._v("\n    " + _vm._s(_vm.requestCommentsTotal) + "\n  "),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("font-awesome-icon", {
          staticClass: "margin-right-2xs",
          staticStyle: { color: "var(--fa-gravy)" },
          attrs: {
            icon: _vm.$v6.regular.faFaceSmile,
            "fixed-width": "",
            size: "lg",
          },
        }),
        _vm._v("\n    " + _vm._s(_vm.requestReactionsTotal) + "\n  "),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }